export const checkinModalGlobal = {
  header: {
    phone: "Telefono",
    accommodation: "Alloggio",
    checkin: "Check-in",
    booking: "Prenotazione",
    notAvailable: "Non disponibile",
    notLinked: "Non collegato",
    defaultGuestName: "Ospite",
  },
  roles: {
    botStaff: "BOT / STAFF",
    guest: "OSPITE",
  },
  media: {
    imageAlt: "Immagine inviata",
    locationReceived: "📍 Posizione ricevuta",
    openInMaps: "Apri in Google Maps",
    viewCoordinates: "Visualizza coordinate ({lat}, {lng})",
    viewFile: "Visualizza file",
    document: "Documento",
  },
  dropzone: {
    text: "Rilascia per allegare i file",
  },
  failure: {
    notSent: "Non inviato",
    notSentDefault: "Non inviato",
    reasons: {
      paymentIssue: "problema di pagamento sull'account WhatsApp",
      cannotReceive: "il numero non può ricevere messaggi WhatsApp",
      downloadFailed: "WhatsApp non è riuscito a scaricare il file",
      templateMissingData: "mancano dei dati nel modello",
      requirementsNotMet: "il messaggio non soddisfa i requisiti di WhatsApp",
    },
  },
  mode: {
    ai: "AI",
    manual: "Manuale",
    autoReplyBanner: "L'agente sta rispondendo automaticamente a questo ospite.",
  },
  predefined: {
    header: "Risposte predefinite",
    empty: "Nessuna risposta predefinita trovata",
  },
  input: {
    attachFile: "Allega file",
    placeholder: "Inizia con / per scegliere una risposta predefinita.",
    removeFile: "Rimuovi file",
  },
  toasts: {
    noBookingLinkedSummary: "Nessuna prenotazione collegata",
    noBookingLinkedDetail: "Non c'è nessuna prenotazione associata a questa conversazione",
    errorSummary: "Errore",
    userIdError: "Impossibile ottenere l'ID utente",
    manualModeSummary: "Modalità manuale attivata",
    aiModeSummary: "Agente AI attivato",
    manualModeDetail: "Risponderai ai messaggi manualmente",
    aiModeDetail: "Il bot risponderà automaticamente",
    modeChangeError: "Impossibile cambiare la modalità della chat",
    reactivateIdError: "Impossibile identificare la conversazione da riattivare.",
    successSummary: "Operazione riuscita",
    templateSentOk: "Modello inviato correttamente.",
    templateSentError: "Impossibile inviare il modello di riattivazione.",
    fileTypeSummary: "Tipo di file non consentito",
    fileTypeDetail: "{name} non è un'immagine né un PDF.",
    fileSizeSummary: "File troppo grande",
    fileSizeDetail: "{name} supera il limite di 5 MB.",
    sendError: "Impossibile inviare il messaggio",
  },
};
